export const formatUiErrors = (errors) => {
  if (!errors) {
    return "There was an error loading the application. Please contact Shelter Animals Count for support.";
  }

  if (Array.isArray(errors)) {
    if (errors.length === 0) {
      return "An unexpected error occurred. Please check your input.";
    }

    if (errors.every((error) => typeof error === "string")) {
      return errors.join(", ");
    }

    return errors
      .map((e) => e?.message || e?.toString() || "Unknown error detail")
      .join(", ");
  }

  if (errors instanceof Error) {
    return (
      errors.message ||
      "An error occurred, but no specific message was provided."
    );
  }

  if (typeof errors === "string") {
    return errors;
  }

  return "An unknown error occurred.";
};
